module.exports = __webpack_public_path__ + "static/img/help9.bfba268e.png";